import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const BulkOperationsPanel = ({ selectedCount, onBulkOperation, onClearSelection }) => {
  const [operation, setOperation] = useState('');
  const [roleValue, setRoleValue] = useState('buyer');

  const handleExecute = () => {
    if (operation === 'changeRole') {
      onBulkOperation(operation, roleValue);
    } else {
      onBulkOperation(operation);
    }
    setOperation('');
  };

  return (
    <div className="bg-primary/5 border border-primary/20 rounded-lg p-4 mb-6">
      <div className="flex items-center justify-between flex-wrap gap-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-primary flex items-center justify-center">
            <Icon name="CheckSquare" size={20} className="text-primary-foreground" />
          </div>
          <div>
            <p className="font-semibold text-foreground">
              {selectedCount} user{selectedCount !== 1 ? 's' : ''} selected
            </p>
            <p className="text-xs text-muted-foreground">
              Choose a bulk operation to apply
            </p>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <Select
            value={operation}
            onChange={(e) => setOperation(e?.target?.value)}
            className="min-w-[200px]"
          >
            <option value="">Select operation...</option>
            <option value="verify">Verify Users</option>
            <option value="unverify">Unverify Users</option>
            <option value="changeRole">Change Role</option>
          </Select>

          {operation === 'changeRole' && (
            <Select
              value={roleValue}
              onChange={(e) => setRoleValue(e?.target?.value)}
              className="min-w-[150px]"
            >
              <option value="buyer">Buyer</option>
              <option value="traveler">Traveler</option>
              <option value="admin">Admin</option>
            </Select>
          )}

          <Button
            variant="default"
            iconName="Play"
            onClick={handleExecute}
            disabled={!operation}
          >
            Execute
          </Button>

          <Button
            variant="ghost"
            iconName="X"
            onClick={onClearSelection}
          >
            Clear
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkOperationsPanel;